// Login Auth action type.
export const LOGIN_USER = "LOGIN_USER";
export const LOGIN_USER_SUCCESS = "LOGIN_USER_SUCCESS";
export const CHECK_LOGIN = "CHECK_LOGIN";
export const LOGIN_FAILD = "LOGIN_FAILD";

// admin setting action type.
// designation action type.
export const GET_DESIGNATION = "GET_DESIGNATION";
export const GET_DESIGNATION_SUCCESS = "GET_DESIGNATION_SUCCESS";
export const ADD_DESIGINATION = "ADD_DESIGINATION";
export const ADD_DESIGINATION_SUCCESS = "ADD_DESIGINATION_SUCCESS";
export const UPDATE_DESIGNATION = "UPDATE_DESIGNATION";
export const UPDATE_DESIGNATION_SUCCESS = "UPDATE_DESIGNATION_SUCCESS";
export const DEL_DESIGNATION = "DEL_DESIGNATION";
export const DEL_DESIGNATION_SUCCESS = "DEL_DESIGNATION_SUCCESS";

// department action type.
export const GET_DEPARTMENT = "GET_DEPARTMENT";
export const GET_DEPARTMENT_SUCCESS = "GET_DEPARTMENT_SUCCESS";
export const ADD_DEPARTMENT = "ADD_DEPARTMENT";
export const ADD_DEPARTMENT_SUCCESS = "ADD_DEPARTMENT_SUCCESS";
export const UPDATE_DEPARTMENT = "UPDATE_DEPARTMENT";
export const UPDATE_DEPARTMENT_SUCCESS = "UPDATE_DEPARTMENT_SUCCESS";
export const DELETE_DEPARTMENT = "DELETE_DEPARTMENT";
export const DELETE_DEPARTMENT_SUCCESS = "DELETE_DEPARTMENT_SUCCESS";

// work permise.
export const GET_WORKPRIMISE = "GET_WORKPRIMISE";
export const GET_WORKPRIMISE_SUCCESS = "GET_WORKPRIMISE_SUCCESS";
export const ADD_WORKPRIMISE = "ADD_WORKPRIMISE";
export const ADD_WORKPRIMISE_SUCCESS = "ADD_WORKPRIMISE_SUCCESS";
export const UPDATE_WORKPRIMISE = "UPDATE_WORKPRIMISE";
export const UPDATE_WORKPRIMISE_SUCCESS = "UPDATE_WORKPRIMISE_SUCCESS";
export const DEL_WORKPRIMISE = "DEL_WORKPRIMISE";
export const DEL_WORKPRIMISE_SUCCESS = "DEL_WORKPRIMISE_SUCCESS";
// reward.
export const GET_REWARDS = "GET_REWARDS";
export const GET_REWARDS_SUCCESS = "GET_REWARDS_SUCCESS";
export const ADD_REWARDS = "ADD_REWARDS";
export const ADD_REWARDS_SUCCESS = "ADD_REWARDS_SUCCESS";
export const UPDATE_REWARDS = "UPDATE_REWARDS";
export const UPDATE_REWARDS_SUCCESS = "UPDATE_REWARDS_SUCCESS";
export const DEL_REWADRDS = "DEL_REWADRDS";
export const DEL_REWADRDS_SUCCESS = "DEL_REWADRDS_SUCCESS";
// officeLocation action type.
export const GET_OFFICELOCATION = "GET_OFFICELOCATION";
export const GET_OFFICELOCATION_SUCCESS = "GET_OFFICELOCATION_SUCCESS";
export const ADD_OFFICELOCATION = "ADD_OFFICELOCATION";
export const ADD_OFFICELOCATION_SUCCESS = "ADD_OFFICELOCATION_SUCCESS";
export const UPDATE_OFFICELOCATION = "UPDATE_OFFICELOCATION";
export const UPDATE_OFFICELOCATION_SUCCESS = "UPDATE_OFFICELOCATION_SUCCESS";
export const DEL_OFFICELOCATION = "DEL_OFFICELOCATION";
export const DEL_OFFICELOCATION_SUCCESS = "DEL_OFFICELOCATION_SUCCESS";
export const DEL_OFFICELOCATION_ERROR="DEL_OFFICELOCATION_ERROR";
// asset action type.
export const GET_SELECTED_ASSET = "GET_SELECTED_ASSET";
export const GET_ASSET = "GET_ASSET";
export const GET_ASSET_SUCCESS = "GET_ASSET_SUCCESS";
export const ADD_ASSET = "ADD_ASSET";
export const ADD_ASSET_SUCCESS = "ADD_ASSET_SUCCESS";
export const UPDATE_ASSET = "UPDATE_ASSET";
export const UPDATE_ASSET_SUCCESS = "UPDATE_ASSET_SUCCESS";
export const DEL_ASSET = "DEL_ASSET";
export const DEL_ASSET_SUCCESS = "DEL_ASSET_SUCCESS";
export const DEL_ASSET_ITEMS = "DEL_ASSET_ITEMS";
export const DEL_ASSET_ITEMS_SUCCESS = "DEL_ASSET_ITEMS_SUCCESS";

// Item action type.
export const GET_ITEMS = "GET_ITEMS";
export const GET_ITEMS_SUCCESS = "GET_ITEMS_SUCCESS";
export const ADD_ITEM = "ADD_ITEM";
export const ADD_ITEM_SUCCESS = "ADD_ITEM_SUCCESS";
export const UPDATE_ITEM = "UPDATE_ITEM";
export const UPDATE_ITEM_SUCCESS = "UPDATE_ITEM_SUCCESS";
export const DEL_ITEM = "DEL_ITEM";
export const DEL_ITEM_SUCCESS = "DEL_ITEM_SUCCESS";

// admin setting action type  END.

// Process rewards action type.
export const GET_PROCESS_REWARDS = "GET_PROCESS_REWARDS";
export const GET_PROCESS_REWARDS_SUCCESS = "GET_PROCESS_REWARDS_SUCCESS";

// Task action type.

export const GET_EMP_WORKING_PROJECTS = "GET_EMP_WORKING_PROJECTS";
export const GET_EMP_WORKING_PROJECTS_SUCCESS =
  "GET_EMP_WORKING_PROJECTS_SUCCESS";

export const GET_EMP_TASK = "GET_EMP_TASK";
export const GET_EMP_TASK_SUCCESS = "GET_EMP_TASK_SUCCESS";
export const GET_ALL_TASK_OF_PROJECT = "GET_ALL_TASK_OF_PROJECT";
export const GET_ALL_TASK_OF_PROJECT_SUCCESS =
  "GET_ALL_TASK_OF_PROJECT_SUCCESS";
export const GET_PROJECT_ID_TASK = "GET_PROJECT_ID_TASK";
export const ADD_TASK = "ADD_TASK";
export const ADD_TASK_SUCCESS = "ADD_TASK_SUCCESS";
export const UPDATE_TASK = "UPDATE_TASK";
export const UPDATE_TASK_SUCCESS = "UPDATE_TASK_SUCCESS";
export const DEL_TASK = "DEL_TASK";
export const DEL_TASK_SUCCESS = "DEL_TASK_SUCCESS";
export const ON_CHANGE_TASK_DATE = "ON_CHANGE_TASK_DATE";
export const ADD_PROJECT_FROM_TASK = "ADD_PROJECT_FROM_TASK";
export const UPDATE_STATUS_TASK = "UPDATE_STATUS_TASK";
export const UPDATE_STATUS_TASK_SUCCESS = "UPDATE_STATUS_TASK_SUCCESS";

// Employee Type action type.
export const GET_EMPLOYEETYPE_LIST = "GET_EMPLOYEETYPE_LIST";
export const GET_EMPLOYEETYPE_LIST_SUCCESS = "GET_EMPLOYEETYPE_LIST_SUCCESS";
export const GET_EMPLOYEETYPES_BY_ID = "GET_EMPLOYEETYPES_BY_ID";
export const GET_EMPLOYEETYPES_BY_ID_SUCCESS =
  "GET_EMPLOYEETYPES_BY_ID_SUCCESS";
export const ADD_EMPLOYEETYPE = "ADD_EMPLOYEETYPE";
export const ADD_EMPLOYEETYPE_SUCCESS = "ADD_EMPLOYEETYPE_SUCCESS";
export const UPDATE_EMPLOYEETYPE = "UPDATE_EMPLOYEETYPE";
export const UPDATE_EMPLOYEETYPE_SUCCESS = "UPDATE_EMPLOYEETYPE_SUCCESS";
export const DELETE_EMPLOYEETYPE = "DELETE_EMPLOYEETYPE";
export const DELETE_EMPLOYEETYPE_SUCCESS = "DELETE_EMPLOYEETYPE_SUCCESS";

// Employee action type.
export const GET_EMP_LIST = "GET_EMP_LIST";
export const GET_EMP_LIST_SUCCESS = "GET_EMP_LIST_SUCCESS";
export const ADD_EMP = "ADD_EMP";
export const ADD_EMP_SUCCESS = "ADD_EMP_SUCCESS";
export const DEL_EMP = "DEL_EMP";
export const DEL_EMP_SUCCESS = "DEL_EMP_SUCCESS";
export const UPDATE_EMP = "UPDATE_EMP";
export const UPDATE_EMP_SUCCESS = "UPDATE_EMP_SUCCESS";

export const GET_SELECT_EMP = "GET_SELECT_EMP";
export const GET_SELECT_EMP_SUCCESS = "GET_SELECT_EMP_SUCCESS";

export const GET_EMP_CERTIFICATE = "GET_EMP_CERTIFICATE";
export const GET_EMP_CERTIFICATE_SUCCESS = "GET_EMP_CERTIFICATE_SUCCESS";
export const ADD_EMP_CERTIFICATE = "ADD_EMP_CERTIFICATE";
export const ADD_EMP_CERTIFICATE_SUCCESS = "ADD_EMP_CERTIFICATE_SUCCESS";
export const UPDATE_EMP_CERTIFICATE = "UPDATE_EMP_CERTIFICATE";
export const UPDATE_EMP_CERTIFICATE_SUCCESS = "UPDATE_EMP_CERTIFICATE_SUCCESS";
export const DEL_EMP_CERTIFICATE = "DEL_EMP_CERTIFICATE";
export const DEL_EMP_CERTIFICATE_SUCCESS = "DEL_EMP_CERTIFICATE_SUCCESS";

export const GET_EMP_SKILL = "GET_EMP_SKILL";
export const GET_EMP_SKILL_SUCCESS = "GET_EMP_SKILL_SUCCESS";
export const ADD_EMP_SKILL = "ADD_EMP_SKILL";
export const ADD_EMP_SKILL_SUCCESS = "ADD_EMP_SKILL_SUCCESS";
export const DEL_EMP_SKILL = "DEL_EMP_SKILL";
export const DEL_EMP_SKILL_SUCCESS = "DEL_EMP_SKILL_SUCCESS";

//Leave Types
export const GET_LEAVETYPES = "GET_LEAVETYPES";
export const GET_LEAVETYPES_SUCCESS = "GET_LEAVETYPES_SUCCESS";
export const ADD_LEAVETYPES = "ADD_LEAVETYPES";
export const ADD_LEAVETYPES_SUCCESS = "ADD_LEAVETYPES_SUCCESS";
export const UPDATE_LEAVETYPES = "UPDATE_LEAVETYPES";
export const UPDATE_LEAVETYPES_SUCCESS = "UPDATE_LEAVETYPES_SUCCESS";
export const DELETE_LEAVETYPES = "DELETE_LEAVETYPES";
export const DELETE_LEAVETYPES_SUCCESS = "DELETE_LEAVETYPES_SUCCESS";
export const DELETE_APPLIED_LEAVES="DELETE_APPLIED_LEAVES";
export const DELETE_APPLIED_LEAVES_SUCCESS="DELETE_APPLIED_LEAVES_SUCCESS";

// Duty Types
export const GET_DUTYYPES = "GET_DUTYYPES";
export const GET_DUTYYPES_SUCCESS = "GET_DUTYYPES_SUCCESS";
export const ADD_DUTYTYPES = "ADD_DUTYTYPES";
export const ADD_DUTYTYPES_SUCCESS = "ADD_DUTYTYPES_SUCCESS";
export const UPDATE_DUTYTYPES = "UPDATE_DUTYTYPES";
export const UPDATE_DUTYTYPES_SUCCESS = "UPDATE_DUTYTYPES_SUCCESS";
export const DELETE_DUTYTYPES = "DELETE_DUTYTYPES";
export const DELETE_DUTYTYPES_SUCCESS = "DELETE_DUTYTYPES_SUCCESS";
export const DELETE_APPLIED_DUTYS="DELETE_APPLIED_DUTYS";
export const DELETE_APPLIED_DUTYS_SUCCESS="DELETE_APPLIED_DUTYS_SUCCESS";

// Company Policies
export const GET_COMPANY_PLOICIES = "GET_COMPANY_PLOICIES";
export const GET_COMPANY_PLOICIES_SUCCESS = "GET_COMPANY_PLOICIES_SUCCESS";
export const ADD_COMPANY_PLOICIES = "ADD_COMPANY_PLOICIES";
export const ADD_COMPANY_PLOICIES_SUCCESS = "ADD_COMPANY_PLOICIES_SUCCESS";
export const UPDATE_COMPANY_PLOICIES = "UPDATE_COMPANY_PLOICIES";
export const UPDATE_COMPANY_PLOICIES_SUCCESS =
  "UPDATE_COMPANY_PLOICIES_SUCCESS";
export const DELETE_COMPANY_PLOICIES = "DELETE_COMPANY_PLOICIES";
export const DELETE_COMPANY_PLOICIES_SUCCESS =
  "DELETE_COMPANY_PLOICIES_SUCCESS";

// Holiday Calendar
export const GET_HOLIDAY_CALENDAR = "GET_HOLIDAY_CALENDAR";
export const GET_HOLIDAY_CALENDAR_SUCCESS = "GET_HOLIDAY_CALENDAR_SUCCESS";
export const ADD_HOLIDAY_CALENDAR = "ADD_HOLIDAY_CALENDAR";
export const ADD_HOLIDAY_CALENDAR_SUCCESS = "ADD_HOLIDAY_CALENDAR_SUCCESS";
export const UPDATE_HOLIDAY_CALENDAR = "UPDATE_HOLIDAY_CALENDAR";
export const UPDATE_HOLIDAY_CALENDAR_SUCCESS =
  "UPDATE_HOLIDAY_CALENDAR_SUCCESS";
export const DELETE_HOLIDAY_CALENDAR = "DELETE_HOLIDAY_CALENDAR";
export const DELETE_HOLIDAY_CALENDAR_SUCCESS =
  "DELETE_HOLIDAY_CALENDAR_SUCCESS";

//Employee Educational Info
export const GET_EMP_EUCATIONAL_INFO = "GET_EMP_EUCATIONAL_INFO";
export const GET_EMP_EUCATIONAL_INFO_SUCCESS =
  "GET_EMP_EUCATIONAL_INFO_SUCCESS";
export const ADD_EMP_EUCATIONAL_INFO = "ADD_EMP_EUCATIONAL_INFO";
export const ADD_EMP_EUCATIONAL_INFO_SUCCESS =
  "ADD_EMP_EUCATIONAL_INFO_SUCCESS";
export const UPDATE_EMP_EUCATIONAL_INFO = "UPDATE_EMP_EUCATIONAL_INFO";
export const UPDATE_EMP_EUCATIONAL_INFO_SUCCESS =
  "UPDATE_EMP_EUCATIONAL_INFO_SUCCESS";
export const DELETE_EMP_EUCATIONAL_INFO = "DELETE_EMP_EUCATIONAL_INFO";
export const DELETE_EMP_EUCATIONAL_INFO_SUCCESS =
  "DELETE_EMP_EUCATIONAL_INFO_SUCCESS";

//Qualification List
export const GET_EMP_QUALIFICATION = "GET_EMP_QUALIFICATION";
export const GET_EMP_QUALIFICATION_SUCCESS = "GET_EMP_QUALIFICATION_SUCCESS";

//Work Experience List
export const GET_EMP_WORKEXPERIENCE = "GET_EMP_WORKEXPERIENCE";
export const GET_EMP_WORKEXPERIENCE_SUCCESS = "GET_EMP_WORKEXPERIENCE_SUCCESS";

//Previous Company Details
export const GET_EMP_PREVIOUS_COMPANY_DETAILS =
  "GET_EMP_PREVIOUS_COMPANY_DETAILS";
export const GET_EMP_PREVIOUS_COMPANY_DETAILS_SUCCESS =
  "GET_EMP_PREVIOUS_COMPANY_DETAILS_SUCCESS";
export const ADD_PREVIOUS_COMPANY_DETAILS = "ADD_PREVIOUS_COMPANY_DETAILS";
export const ADD_PREVIOUS_COMPANY_DETAILS_SUCCESS =
  "ADD_PREVIOUS_COMPANY_DETAILS_SUCCESS";
export const UPDATE_PREVIOUS_COMPANY_DETAILS =
  "UPDATE_PREVIOUS_COMPANY_DETAILS";
export const UPDATE_PREVIOUS_COMPANY_DETAILS_SUCCESS =
  "UPDATE_PREVIOUS_COMPANY_DETAILS_SUCCESS";
export const DELETE_PREVIOUS_COMPANY_DETAILS =
  "DELETE_PREVIOUS_COMPANY_DETAILS";
export const DELETE_PREVIOUS_COMPANY_DETAILS_SUCCESS =
  "DELETE_PREVIOUS_COMPANY_DETAILS_SUCCESS";

//Previous ProjectList
export const GET_EMP_PREVIOUS_PROJECT_DETAILS =
  "GET_EMP_PREVIOUS_PROJECT_DETAILS";
export const GET_EMP_PREVIOUS_PROJECT_DETAILS_SUCCESS =
  "GET_EMP_PREVIOUS_PROJECT_DETAILS_SUCCESS";
export const ADD_EMP_PREVIOUS_PROJECT_DETAILS =
  "ADD_EMP_PREVIOUS_PROJECT_DETAILS";
export const ADD_EMP_PREVIOUS_PROJECT_DETAILS_SUCCESS =
  "ADD_EMP_PREVIOUS_PROJECT_DETAILS_SUCCESS";
export const UPDATE_EMP_PREVIOUS_PROJECT_DETAILS =
  "UPDATE_EMP_PREVIOUS_PROJECT_DETAILS";
export const UPDATE_EMP_PREVIOUS_PROJECT_DETAILS_SUCCESS =
  "UPDATE_EMP_PREVIOUS_PROJECT_DETAILS_SUCCESS";
export const DELETE_EMP_PREVIOUS_PROJECT_DETAILS =
  "DELETE_EMP_PREVIOUS_PROJECT_DETAILS";
export const DELETE_EMP_PREVIOUS_PROJECT_DETAILS_SUCCESS =
  "DELETE_EMP_PREVIOUS_PROJECT_DETAILS_SUCCESS";

// Projects action type.
export const GET_PROJECT_LIST = "GET_PROJECT_LIST";
export const GET_PROJECT_LIST_SUCCES = "GET_PROJECT_LIST_SUCCES";
export const GET_PROJECT_LIST_OF_EMPLOYEE = "GET_PROJECT_LIST_OF_EMPLOYEE";
export const GET_PROJECT_LIST_OF_EMPLOYEE_SUCCESS =
  "GET_PROJECT_LIST_OF_EMPLOYEE_SUCCESS";
  export const GET_PROJECT_LIST_OF_ADMIN = "GET_PROJECT_LIST_OF_ADMIN";
export const GET_PROJECT_LIST_OF_ADMIN_SUCCESS =
  "GET_PROJECT_LIST_OF_ADMIN_SUCCESS";
export const GET_SELECT_PROJECT = "GET_SELECT_PROJECT";
export const GET_SELECT_PROJECT_SUCCESS = "GET_SELECT_PROJECT_SUCCESS";
export const ADD_PROJECT_LEADER = "ADD_PROJECT_LEADER";
export const ADD_PROJECT_MEMBER = "ADD_PROJECT_MEMBER";
export const ADD_PROJECT = "ADD_PROJECT";
export const ADD_PROJECT_SUCCESS = "ADD_PROJECT_SUCCESS";
export const UPDATE_PROJECT = "UPDATE_PROJECT";
export const UPDATE_PROJECT_SUCCESS = "UPDATE_PROJECT_SUCCESS";
export const DEL_PROJECT = " DEL_PROJECT";
export const DEL_PROJECT_SUCCESS = " DEL_PROJECT_SUCCESS";
// Skill action type.
export const GET_SKILL = "GET_SKILL";
export const GET_SKILL_SUCCESS = "GET_SKILL_SUCCESS";
export const ADD_SKILL = "ADD_SKILL";
export const ADD_SKILL_SUCCESS = "ADD_SKILL_SUCCESS";
export const UPDATE_SKILL = "UPDATE_SKILL";
export const UPDATE_SKILL_SUCCESS = "UPDATE_SKILL_SUCCESS";
export const DEL_SKILL = "DEL_SKILL";
export const DEL_SKILL_SUCCESS = "DEL_SKILL_SUCCESS";
// payroll action type.
export const GET_PAYROLL_ITEM = "GET_PAYROLL_ITEM";
export const GET_PAYROLL_ITEM_SUCCESS = "GET_PAYROLL_ITEM_SUCCESS";
export const ADD_PAYROLL_ITEM = "ADD_PAYROLL_ITEM";
export const ADD_PAYROLL_ITEM_SUCCESS = "ADD_PAYROLL_ITEM_SUCCESS";
export const UPDATE_PAYROLL_ITEM = "UPDATE_PAYROLL_ITEM";
export const UPDATE_PAYROLL_ITEM_SUCCESS = "UPDATE_PAYROLL_ITEM_SUCCESS";
export const DEL_PAYROLL_ITEM = "DEL_PAYROLL_ITEM";
export const DEL_PAYROLL_ITEM_SUCCESS = "DEL_PAYROLL_ITEM_SUCCESS";

// Ticket action type.
export const GET_ALL_TICKET = "GET_ALL_TICKET";
export const GET_ALL_TICKET_SUCCESS = "GET_ALL_TICKET_SUCCESS";
export const GET_TICKET_BY_ID = "GET_TICKET_BY_ID";
export const GET_TICKET_BY_ID_SUCCESS = "GET_TICKET_BY_ID_SUCCESS";

// skillcategory action type.
export const GET_SKILLCATEGORY = "GET_SKILLCATEGORY";
export const GET_SKILLCATEGORY_SUCCESS = "GET_SKILLCATEGORY_SUCCESS";
export const ADD_SKILLCATEGORY = "ADD_SKILLCATEGORY";
export const ADD_SKILLCATEGORY_SUCCESS = "ADD_SKILLCATEGORY_SUCCESS";
export const UPDATE_SKILLCATEGORY = "UPDATE_SKILLCATEGORY";
export const UPDATE_SKILLCATEGORY_SUCCESS = "UPDATE_SKILLCATEGORY_SUCCESS";
export const DELETE_SKILLCATEGORY = "DELETE_SKILLCATEGORY";
export const DELETE_SKILLCATEGORY_SUCCESS = "DELETE_SKILLCATEGORY_SUCCESS";
export const DELETE_SKILLCATEGORY_ERROR = "DELETE_SKILLCATEGORY_ERROR";

//admin settings skills actiontype
export const GET_ADMIN_SKILLS = "GET_ADMIN_SKILLS";
export const GET_ADMIN_SKILLS_SUCCESS = "GET_ADMIN_SKILLS_SUCCESS";
export const ADD_ADMIN_SKILLS = "ADD_ADMIN_SKILLS";
export const ADD_ADMIN_SKILLS_SUCCESS = "ADD_ADMIN_SKILLS_SUCCESS";
export const UPDATE_ADMIN_SKILLS = "UPDATE_ADMIN_SKILLS";
export const UPDATE_ADMIN_SKILLS_SUCCESS = "UPDATE_ADMIN_SKILLS_SUCCESS";
export const DELETE_ADMIN_SKILLS = "DELETE_ADMIN_SKILLS";
export const DELETE_ADMIN_SKILLS_SUCCESS = "DELETE_ADMIN_SKILLS_SUCCESS";


// Certification.
export const GET_CERTIFICATIONS = "GET_CERTIFICATIONS";
export const GET_CERTIFICATIONS_SUCCESS = "GET_CERTIFICATIONS_SUCCESS";
export const ADD_CERTIFICATION = "ADD_CERTIFICATION";
export const ADD_CERTIFICATION_SUCCESS = "ADD_CERTIFICATION_SUCCESS";
export const UPDATE_CERTIFICATION = "UPDATE_CERTIFICATION";
export const UPDATE_CERTIFICATION_SUCCESS = "UPDATE_CERTIFICATION_SUCCESS";
export const DELETE_CERTIFICATION = "DELETE_CERTIFICATION";
export const DELETE_CERTIFICATION_SUCCESS = "DELETE_CERTIFICATION_SUCCESS";

// Technologies.
export const GET_TECHNOLOGIES = "GET_TECHNOLOGIES";
export const GET_TECHNOLOGIES_SUCCESS = "GET_TECHNOLOGIES_SUCCESS";
export const ADD_TECHNOLOGY = "ADD_TECHNOLOGY";
export const ADD_TECHNOLOGY_SUCCESS = "ADD_TECHNOLOGY_SUCCESS";
export const UPDATE_TECHNOLOGY = "UPDATE_TECHNOLOGY";
export const UPDATE_TECHNOLOGY_SUCCESS = "UPDATE_TECHNOLOGY_SUCCESS";
export const DELETE_TECHNOLOGY = "DELETE_TECHNOLOGY";
export const DELETE_TECHNOLOGY_SUCCESS = "DELETE_TECHNOLOGY_SUCCESS";

//Employee Rewards.
export const GET_EMPLOYEE_REWARDS = "GET_EMPLOYEE_REWARDS";
export const GET_EMPLOYEE_REWARDS_SUCCESS = "GET_EMPLOYEE_REWARDS_SUCCESS";
export const GET_EMPLOYEE_REWARDS_REDEEM_LIST = "GET_EMPLOYEE_REWARDS_REDEEM_LIST";
export const GET_EMPLOYEE_REWARDS_REDEEM_LIST_SUCCESS = "GET_EMPLOYEE_REWARDS_REDEEM_LIST_SUCCESS";

//Employee Task Unlock Req.
export const ADD_TASK_UNLOCK_REQUEST = "ADD_TASK_UNLOCK_REQUEST";
export const ADD_TASK_UNLOCK_REQUEST_SUCCESS = "ADD_TASK_UNLOCK_REQUEST_SUCCESS";
export const GET_TASK_UNLOCK_REQUEST = "GET_TASK_UNLOCK_REQUEST";
export const GET_TASK_UNLOCK_REQUEST_SUCCESS = "GET_TASK_UNLOCK_REQUEST_SUCCESS";
export const GET_Leave_REQUEST = "GET_Leave_REQUEST";
export const GET_Leave_REQUEST_SUCCESS = "GET_Leave_REQUEST_SUCCESS";

//Appraisal
export const GET_APPRAISAL_QUESTIONS = "GET_APPRAISAL_QUESTIONS";
export const GET_APPRAISAL_QUESTIONS_SUCCESS = "GET_APPRAISAL_QUESTIONS_SUCCESS";
export const SAVEAPPRAISEEDETAILS_SELFREVIEW = "SAVEAPPRAISEEDETAILS_SELFREVIEW";
export const SAVEAPPRAISEEDETAILS_SELFREVIEW_SUCCESS = "SAVEAPPRAISEEDETAILS_SELFREVIEW_SUCCESS";
export const GET_APPRAISEE_DETAILS = "GET_APPRAISEE_DETAILS";
export const GET_APPRAISEE_DETAILS_SUCCESS = "GET_APPRAISEE_DETAILS_SUCCESS";
export const GET_EXPERTLEVEL = "GET_EXPERTLEVEL";
export const GET_EXPERTLEVEL_SUCCESS = "GET_EXPERTLEVEL_SUCCESS";
export const ADD_GOALS_ACHIEVED = "ADD_GOALS_ACHIEVED";
export const ADD_GOALS_ACHIEVED_SUCCESS = "ADD_GOALS_ACHIEVED_SUCCESS";
export const GET_GOALS_ACHIEVED = "GET_GOALS_ACHIEVED";
export const GET_GOALS_ACHIEVED_SUCCESS = "GET_GOALS_ACHIEVED_SUCCESS";
export const GET_GOALS_BY_DESIGNATION = "GET_GOALS_BY_DESIGNATION";
export const GET_GOALS_BY_DESIGNATION_SUCCESS = "GET_GOALS_BY_DESIGNATION_SUCCESS";
export const DELETE_PERFOMANCE_GOALS="DELETE_PERFOMANCE_GOALS";
export const DELETE_PERFOMANCE_GOALS_SUCCESS="DELETE_PERFOMANCE_GOALS_SUCCESS";
export const GET_PERFOMANCE_GOALS="GET_PERFOMANCE_GOALS";
export const GET_PERFOMANCE_GOALS_SUCCESS="GET_PERFOMANCE_GOALS_SUCCESS";
export const DELETE_TECHNICAL_CAPABILITY="DELETE_TECHNICAL_CAPABILITY";
export const DELETE_TECHNICAL_CAPABILITY_SUCCESS="DELETE_TECHNICAL_CAPABILITY_SUCCESS";
export const DELETE_BEHAVIORAL_ATTRIBUTE_APPRAISAL="DELETE_BEHAVIORAL_ATTRIBUTE_APPRAISAL";
export const DELETE_BEHAVIORAL_ATTRIBUTE_APPRAISAL_SUCCESS="DELETE_BEHAVIORAL_ATTRIBUTE_APPRAISAL_SUCCESS";
export const DELETE_GOALS_ACHIEVED="DELETE_GOALS_ACHIEVED";
export const DELETE_GOALS_ACHIEVED_SUCCESS="DELETE_GOALS_ACHIEVED_SUCCESS";
export const GET_RATING_LIST = "GET_RATING_LIST";
export const GET_RATING_LIST_SUCCESS = "GET_RATING_LIST_SUCCESS";
export const SAVE_PERFORMANCEGOALS = "SAVE_PERFORMANCEGOALS";
export const SAVE_PERFORMANCEGOALS_SUCCESS = "SAVE_PERFORMANCEGOALS_SUCCESS";
export const GET_APPRAISEE_PERFORMANCEGOALS = "GET_APPRAISEE_PERFORMANCEGOALS";
export const GET_APPRAISEE_PERFORMANCEGOALS_SUCCESS = "GET_APPRAISEE_PERFORMANCEGOALS_SUCCESS";
export const GET_POTENTIAL_LIST = "GET_POTENTIAL_LIST";
export const GET_POTENTIAL_LIST_SUCCESS = "GET_POTENTIAL_LIST_SUCCESS";
export const SAVE_TECHNICAL_CAPABILITY = "SAVE_TECHNICAL_CAPABILITY";
export const SAVE_TECHNICAL_CAPABILITY_SUCCESS = "SAVE_TECHNICAL_CAPABILITY_SUCCESS";
export const GET_TECHNICAL_CAPABILITY = "GET_TECHNICAL_CAPABILITY";
export const GET_TECHNICAL_CAPABILITY_SUCCESS = "GET_TECHNICAL_CAPABILITY_SUCCESS";
export const GET_ATTRIBUTE_LIST = "GET_ATTRIBUTE_LIST";
export const GET_ATTRIBUTE_LIST_SUCCESS = "GET_ATTRIBUTE_LIST_SUCCESS";
export const SAVE_BEHAVIOUR_ATTRIBUTES = "SAVE_BEHAVIOUR_ATTRIBUTES";
export const SAVE_BEHAVIOUR_ATTRIBUTES_SUCCESS = "SAVE_BEHAVIOUR_ATTRIBUTES_SUCCESS";
export const GET_BEHAVIOUR_ATTRIBUTES = "GET_BEHAVIOUR_ATTRIBUTES";
export const GET_BEHAVIOUR_ATTRIBUTES_SUCCESS = "GET_BEHAVIOUR_ATTRIBUTES_SUCCESS";
export const SAVE_PERFORMANCE_LEARNING_PLAN = "SAVE_PERFORMANCE_LEARNING_PLAN";
export const SAVE_PERFORMANCE_LEARNING_PLAN_SUCCESS = "SAVE_PERFORMANCE_LEARNING_PLAN_SUCCESS";
export const GET_PERFORMANCE_LEARNING_PLAN = "GET_PERFORMANCE_LEARNING_PLAN";
export const GET_PERFORMANCE_LEARNING_PLAN_SUCCESS = "GET_PERFORMANCE_LEARNING_PLAN_SUCCESS";
export const SUBMITDATA = "SUBMITDATA";
export const SUBMITDATA_SUCCESS = "SUBMITDATA_SUCCESS";
//Review
export const GET_REVIEW_APPRAISEE_LIST = "GET_REVIEW_APPRAISEE_LIST";
export const GET_REVIEW_APPRAISEE_LIST_SUCCESS = "GET_REVIEW_APPRAISEE_LIST_SUCCESS";

export const GET_APPRAISAL_ENABLE_ADMIN_LIST = "GET_APPRAISAL_ENABLE_ADMIN_LIST";
export const GET_APPRAISAL_ENABLE_ADMIN_LIST_SUCCESS = "GET_APPRAISAL_ENABLE_ADMIN_LIST_SUCCESS";
export const ENABLE_ALL_APPRAISEE = "ENABLE_ALL_APPRAISEE";
export const ENABLE_ALL_APPRAISEE_SUCCESS = "ENABLE_ALL_APPRAISEE_SUCCESS";

export const CHECK_APPRAISAL_ENABLED_STATE = "CHECK_APPRAISAL_ENABLED_STATE";
export const CHECK_APPRAISAL_ENABLED_STATE_SUCCESS = "CHECK_APPRAISAL_ENABLED_STATE_SUCCESS";


//Review Rating
export const GET_REVIEWRATINGS = "GET_REVIEWRATINGS";
export const GET_REVIEWRATINGS_SUCCESS = "GET_REVIEWRATINGS_SUCCESS";
export const ADD_REVIEWRATINGS = "ADD_REVIEWRATINGS";
export const ADD_REVIEWRATINGS_SUCCESS = "ADD_REVIEWRATINGS_SUCCESS";
export const UPDATE_REVIEWRATINGS = "UPDATE_REVIEWRATINGS";
export const UPDATE_REVIEWRATINGS_SUCCESS = "UPDATE_REVIEWRATINGS_SUCCESS";
export const DELETE_REVIEWRATINGS = "DELETE_REVIEWRATINGS";
export const DELETE_REVIEWRATINGS_SUCCESS = "DELETE_REVIEWRATINGS_SUCCESS";

//Excel import

export const ADD_EMPLOYEEEXCEL = "ADD_EMPLOYEEEXCEL";
export const ADD_EMPLOYEEEXCEL_SUCCESS = "ADD_EMPLOYEEEXCEL_SUCCESS";
//Excel import

export const ADD_ASSETEXCEL = "ADD_ASSETEXCEL";
export const ADD_ASSETEXCEL_SUCCESS = "ADD_ASSETEXCEL_SUCCESS";
//behavioral attributes
export const GET_BEHAVIORALATTRIBUTES= "GET_BEHAVIORALATTRIBUTES";
export const GET_BEHAVIORALATTRIBUTES_SUCCESS = "GET_BEHAVIORALATTRIBUTES_SUCCESS";
export const ADD_BEHAVIORALATTRIBUTES = "ADD_BEHAVIORALATTRIBUTES";
export const ADD_BEHAVIORALATTRIBUTES_SUCCESS = "ADD_BEHAVIORALATTRIBUTES_SUCCESS";
export const UPDATE_BEHAVIORALATTRIBUTES = "UPDATE_BEHAVIORALATTRIBUTES";
export const UPDATE_BEHAVIORALATTRIBUTES_SUCCESS = "UPDATE_BEHAVIORALATTRIBUTES_SUCCESS";
export const DELETE_BEHAVIORALATTRIBUTES = "DELETE_BEHAVIORALATTRIBUTES";
export const DELETE_BEHAVIORALATTRIBUTES_SUCCESS = "DELETE_BEHAVIORALATTRIBUTES_SUCCESS";

//Appraisee potential
export const GET_POTENTIAL = "GET_POTENTIAL";
export const GET_POTENTIAL_SUCCESS = "GET_POTENTIAL_SUCCESS";
export const ADD_POTENTIAL = "ADD_POTENTIAL";
export const ADD_POTENTIAL_SUCCESS = "ADD_POTENTIAL_SUCCESS";
export const UPDATE_POTENTIAL = "UPDATE_POTENTIAL";
export const UPDATE_POTENTIAL_SUCCESS = "UPDATE_POTENTIAL_SUCCESS";
export const DELETE_POTENTIAL = "DELETE_POTENTIAL";
export const DELETE_POTENTIAL_SUCCESS = "DELETE_POTENTIAL_SUCCESS";

//Role
export const GET_ROLE = "GET_ROLE";
export const GET_ROLE_SUCCESS = "GET_ROLE_SUCCESS";
export const ADD_ROLE = "ADD_ROLE";
export const ADD_ROLE_SECCESS = "ADD_ROLE_SECCESS";
export const UPDATE_ROLE = "UPDATE_ROLE";
export const UPDATE_ROLE_SUCCESS = "UPDATE_ROLE_SUCCESS";
export const DELETE_ROLE = "DELETE_ROLE";
export const DELETE_ROLE_SUCCESS = "DELETE_ROLE_SUCCESS";


export const GET_PRIMARYGOAL = "GET_PRIMARYGOAL";
export const GET_GOALS_SUCCESS = "GET_GOALS_SUCCESS";
export const ADD_PRIMARY_GOALS = "ADD_PRIMARY_GOALS";
export const ADD_PRIMARY_GOALS_SUCCESS = "ADD_PRIMARY_GOALS_SUCCESS";
export const UPDATE_PRIMARY_GOALS = "UPDATE_PRIMARY_GOALS";
export const UPDATE_PRIMARY_GOALS_SUCCESS = "UPDATE_PRIMARY_GOALS_SUCCESS";
export const DELETE_PRIMARY_GOALS = "DELETE_PRIMARY_GOALS";
export const DELETE_PRIMARY_GOALS_SUCCESS = "DELETE_PRIMARY_GOALS_SUCCESS";

//export const GET_ALLAPPRAISAL_QUESTIONS ="GET_ALLAPPRAISAL_QUESTIONS"
//export const GET_ALLAPPRAISAL_QUESTIONS_SUCCESS ="GET_ALLAPPRAISAL_QUESTIONS_SUCCESS"
export const ADD_APPRAISAL_QUESTIONS ="ADD_APPRAISAL_QUESTIONS";
export const UPDATE_APPRAISAL_QUESTIONS ="UPDATE_APPRAISAL_QUESTIONS";
export const DELETE_APPRAISAL_QUESTIONS ="DELETE_APPRAISAL_QUESTIONS";
export const ADD_APPRAISAL_QUESTIONS_SUCESS ="ADD_APPRAISAL_QUESTIONS_SUCESS";
export const UPDATE_APPRAISAL_QUESTIONS_SUCESS="UPDATE_APPRAISAL_QUESTIONS_SUCESS";
export const DELETE_APPRAISAL_QUESTIONS_SUCESS="DELETE_APPRAISAL_QUESTIONS_SUCESS";
export const DELETE_APPRAISAL_QUESTIONS_ERROR="DELETE_APPRAISAL_QUESTIONS_ERROR";


//Calendar Year
export const GET_CALENDARYEAR = "GET_CALENDARYEAR";
export const GET_CALENDARYEAR_SUCCESS = "GET_CALENDARYEAR_SUCCESS";
export const ADD_CALENDARYEAR = "ADD_CALENDARYEAR";
export const ADD_CALENDARYEAR_SUCCESS = "ADD_CALENDARYEAR_SUCCESS";
export const UPDATE_CALENDARYEAR = "UPDATE_CALENDARYEAR";
export const UPDATE_CALENDARYEAR_SUCCESS = "UPDATE_CALENDARYEAR_SUCCESS";
export const DELETE_CALENDARYEAR = "DELETE_CALENDARYEAR";
export const DELETE_CALENDARYEAR_SUCCESS = "DELETE_CALENDARYEAR_SUCCESS";

// Recursive and holiday list
export const GET_RECANDHOLIDAY_CALENDAR = "GET_RECANDHOLIDAY_CALENDAR";
export const GET_RECANDHOLIDAY_CALENDAR_SUCCESS = "GET_RECANDHOLIDAY_CALENDAR_SUCCESS";
export const ADD_RECANDHOLIDAY_CALENDAR = "ADD_RECANDHOLIDAY_CALENDAR";
export const ADD_RECANDHOLIDAY_CALENDAR_SUCCESS = "ADD_RECANDHOLIDAY_CALENDAR_SUCCESS";
export const UPDATE_RECANDHOLIDAY_CALENDAR = "UPDATE_RECANDHOLIDAY_CALENDAR";
export const UPDATE_RECANDHOLIDAY_CALENDAR_SUCCESS =
  "UPDATE_RECANDHOLIDAY_CALENDAR_SUCCESS";
export const DELETE_RECANDHOLIDAY_CALENDAR = "DELETE_RECANDHOLIDAY_CALENDAR";
export const DELETE_RECANDHOLIDAY_CALENDAR_SUCCESS =
  "DELETE_RECANDHOLIDAY_CALENDAR_SUCCESS";

  // Shifts list
export const GET_SHIFTS = "GET_SHIFTS";
export const GET_SHIFTS_SUCCESS = "GET_SHIFTS_SUCCESS";
export const ADD_SHIFTS = "ADD_SHIFTS";
export const ADD_SHIFTS_SUCCESS = "ADD_SHIFTS_SUCCESS";
export const UPDATE_SHIFTS = "UPDATE_SHIFTS";
export const UPDATE_SHIFTS_SUCCESS =  "UPDATE_SHIFTS_SUCCESS";
export const DELETE_SHIFTS = "DELETE_SHIFTS";
export const DELETE_SHIFTS_SUCCESS =  "DELETE_SHIFTS_SUCCESS";

//Configure mail
export const GET_CONFIGUREMAIL = "GET_CONFIGUREMAIL";
export const GET_CONFIGUREMAIL_SUCCESS = "GET_CONFIGUREMAIL_SUCCESS";
export const CREATE_CONFIGUREMAIL = "CREATE_CONFIGUREMAIL";
export const CREATE_CONFIGUREMAIL_SUCCESS = "CREATE_CONFIGUREMAIL_SUCCESS";
export const GET_REQUESTTYPE = "GET_REQUESTTYPE";
export const GET_REQUESTTYPE_SUCCESS = "GET_REQUESTTYPE_SUCCESS";
